<template>
    <div style="min-height: 100vh; background-color: #171819" :class="{ 'correct-height': blogView }">
        <MobileHeader :idt="idt" @toggleSidebarParent="toggleSidebarParent" />
        <div class="profile">
            <SideBar
                :is-open="isSidebarOpen"
                @toggleSidebarParentClose="toggleSidebarParentClose"
                @questionRoullette="questionRoullette"
            />
            <!--  RIGHT PROFIL -->
            <!--  RIGHT PROFIL -->
            <div style="height: 80%" v-if="loader">
                <Loader />
            </div>
            <div v-if="user.user_uuid && !loader" class="right-profile">
                <div v-if="blogView" class="blog">
                    <BlogCard :blog="blog" :blog-number="blogNumber" @noPopup="noPopup" />
                </div>

                <!-- POPUP CHALLANGE-->

                <div class="wrapper">
                    <div id="checkClick" class="desktop">
                        <Search />
                        <Notifications />
                    </div>

                    <div v-if="logedIn" style="position: relative">
                        <PayButtonMobile @payUser="payUser" :idt="idt" />
                    </div>
                    <div v-if="logedIn" style="position: relative">
                        <FollowButtonMobile :idt="idt" />
                    </div>
                    <div v-if="logedIn" style="position: relative">
                        <MessageButtonMobile :idt="idt" />
                    </div>

                    <div v-if="popupChallenge" id="checkClickChallenge4">
                        <ChallengeForm
                            :user="user"
                            :popupChallenge="popupChallenge"
                            @changePopup="changePopup"
                            @popupChallangeClose="popupChallangeClose"
                        />
                    </div>
                    <div v-if="openPopupBlockDiv" id="block-form">
                        <BlockForm
                            :user="user"
                            :openPopupBlockDiv="openPopupBlockDiv"
                            @blockClose="blockClose"
                            @refreshUser="refreshUser"
                            @blockChange="blockChange"
                        />
                    </div>
                    <!-- MID 2    -->
                    <div style="position: relative">
                        <BlockUser
                            :user="user"
                            @openPopupBlock="openPopupBlock"
                            :openPopupBlockDiv="openPopupBlockDiv"
                        />

                        <div :class="{ shadow: popupChallenge }" id="middle2">
                            <div class="upload-pic flex-center online-lamp-container">
                                <img
                                    v-if="
                                        user.profile.file_url &&
                                        !user.profile.file_url.includes('fra1.digitaloceanspaces.com') &&
                                        user.profile.file_url !== null
                                    "
                                    class="profile-pic"
                                    :src="user.profile.file_url"
                                    alt="profile-pic"
                                />
                                <img
                                    v-else-if="user.profile.file_url !== null && user.profile.file_size > 10153118"
                                    class="profile-pic"
                                    :src="`https://` + user.profile.file_url"
                                    alt="profile-pic"
                                />
                                <img
                                    v-else-if="
                                        user.profile.file_url !== null && user.profile.file_url.startsWith('fra1')
                                    "
                                    class="profile-pic"
                                    loading="lazy"
                                    :src="
                                        `https://api.outpostchess.com/upload/w_250,ao_1/https://` +
                                        user.profile.file_url
                                    "
                                />
                                <img
                                    v-else-if="
                                        user.profile.file_url !== null && !user.profile.file_url.startsWith('fra1')
                                    "
                                    loading="lazy"
                                    class="profile-pic"
                                    :src="`https://api.outpostchess.com/upload/w_250,ao_1/` + user.profile.file_url"
                                    alt="profile-pic"
                                />
                                <!-- <img
                                v-else-if="user.profile.file_url !== null"
                                class="profile-pic"
                                :src="user.profile.file_url"
                                alt="profile-pic"
                            /> -->

                                <!-- :src="`https://api.outpostchess.com/upload/w_400,ao_1/` + user.profile.file_url" -->
                                <div v-else-if="user.name_first && user.name_last" class="inicials">
                                    <div>
                                        {{ user.name_first.trim().slice(0, 1) }} {{ user.name_last.trim().slice(0, 1) }}
                                    </div>
                                </div>
                                <img
                                    v-else
                                    class="profile-pic"
                                    src="https://outpostchess.fra1.digitaloceanspaces.com/2bf139b2-7074-4fd4-8377-58efead41bf0.png"
                                    alt="profile_pic"
                                />
                                <div
                                    style="text-wrap: nowrap"
                                    v-if="$store.state.onlinePayload[user.user_uuid]"
                                    class="online-lamp"
                                ></div>
                            </div>
                            <div id="middle2-1">
                                <div class="personal-first-line cursor-default">
                                    <p id="profile-name">{{ user.name_first }} {{ user.name_last }}</p>
                                    <svg
                                        v-if="user.verified == true"
                                        class="svg_verified"
                                        :class="{ 'verified-true': user.verified }"
                                        width="19"
                                        height="18"
                                        viewBox="0 0 19 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.59798 17.707L5.01465 15.0404L2.01465 14.3737L2.30632 11.2904L0.264648 8.95703L2.30632 6.6237L2.01465 3.54036L5.01465 2.8737L6.59798 0.207031L9.43132 1.41536L12.2646 0.207031L13.848 2.8737L16.848 3.54036L16.5563 6.6237L18.598 8.95703L16.5563 11.2904L16.848 14.3737L13.848 15.0404L12.2646 17.707L9.43132 16.4987L6.59798 17.707ZM8.55632 11.9154L13.2647 7.20703L12.098 5.9987L8.55632 9.54036L6.76465 7.79037L5.59798 8.95703L8.55632 11.9154Z"
                                            fill="#11C6D1"
                                        />
                                    </svg>
                                    <div class="role-icons sm-hide">
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverPlayer = true"
                                                @mouseleave="hoverPlayer = false"
                                                v-if="user.rola.indexOf('PLAYER') !== -1"
                                                src="../assets/roleIcons/player.svg"
                                                alt="player"
                                            />
                                            <p class="hover-text-icons" :class="{ 'hover-text-active': hoverPlayer }">
                                                Player
                                            </p>
                                        </div>
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverClub = true"
                                                @mouseleave="hoverClub = false"
                                                v-if="user.rola.indexOf('CLUB') !== -1"
                                                src="../assets/roleIcons/club.svg"
                                                alt="club"
                                            />
                                            <p class="hover-text-icons" :class="{ 'hover-text-active': hoverClub }">
                                                Club Admin
                                            </p>
                                        </div>
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverOrganizer = true"
                                                @mouseleave="hoverOrganizer = false"
                                                v-if="user.rola.indexOf('ORGANIZER') !== -1"
                                                src="../assets/roleIcons/organizer.svg"
                                                alt="organizer"
                                            />
                                            <p
                                                class="hover-text-icons"
                                                :class="{ 'hover-text-active': hoverOrganizer }"
                                            >
                                                Organizer
                                            </p>
                                        </div>
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverArbiter = true"
                                                @mouseleave="hoverArbiter = false"
                                                v-if="user.rola.indexOf('ARBITER') !== -1"
                                                src="../assets/roleIcons/arbiter.svg"
                                                alt="arbiter"
                                            />
                                            <p class="hover-text-icons" :class="{ 'hover-text-active': hoverArbiter }">
                                                Arbiter
                                            </p>
                                        </div>
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverTrainer = true"
                                                @mouseleave="hoverTrainer = false"
                                                v-if="user.rola.indexOf('TRAINER') !== -1"
                                                src="../assets/roleIcons/trainer.svg"
                                                alt="trainer"
                                            />
                                            <p class="hover-text-icons" :class="{ 'hover-text-active': hoverTrainer }">
                                                Trainer
                                            </p>
                                        </div>
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverStreamer = true"
                                                @mouseleave="hoverStreamer = false"
                                                v-if="user.rola.indexOf('STREAMER') !== -1"
                                                src="../assets/roleIcons/streamer.svg"
                                                alt="streamer"
                                            />
                                            <p class="hover-text-icons" :class="{ 'hover-text-active': hoverStreamer }">
                                                Streamer
                                            </p>
                                        </div>
                                        <div style="position: relative">
                                            <img
                                                @mouseover="hoverChessbox = true"
                                                @mouseleave="hoverChessbox = false"
                                                v-if="user.rola.indexOf('CHESSBOXER') !== -1"
                                                src="../assets/roleIcons/chess-boxer.svg"
                                                alt="chess-boxer"
                                            />
                                            <p class="hover-text-icons" :class="{ 'hover-text-active': hoverChessbox }">
                                                Chess Boxer
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="role-icons sm-show">
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverPlayer = true"
                                            @mouseleave="hoverPlayer = false"
                                            v-if="user.rola.indexOf('PLAYER') !== -1"
                                            src="../assets/roleIcons/player.svg"
                                            alt="player"
                                        />
                                        <p
                                            class="hover-text-icons-mobile"
                                            :class="{ 'hover-text-active': hoverPlayer }"
                                        >
                                            Player
                                        </p>
                                    </div>
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverClub = true"
                                            @mouseleave="hoverClub = false"
                                            v-if="user.rola.indexOf('CLUB') !== -1"
                                            src="../assets/roleIcons/club.svg"
                                            alt="club"
                                        />
                                        <p class="hover-text-icons-mobile" :class="{ 'hover-text-active': hoverClub }">
                                            Club Admin
                                        </p>
                                    </div>
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverArbiter = true"
                                            @mouseleave="hoverArbiter = false"
                                            v-if="user.rola.indexOf('ARBITER') !== -1"
                                            src="../assets/roleIcons/arbiter.svg"
                                            alt="arbiter"
                                        />
                                        <p
                                            class="hover-text-icons-mobile"
                                            :class="{ 'hover-text-active': hoverArbiter }"
                                        >
                                            Arbiter
                                        </p>
                                    </div>
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverTrainer = true"
                                            @mouseleave="hoverTrainer = false"
                                            v-if="user.rola.indexOf('TRAINER') !== -1"
                                            src="../assets/roleIcons/trainer.svg"
                                            alt="trainer"
                                        />
                                        <p
                                            class="hover-text-icons-mobile"
                                            :class="{ 'hover-text-active': hoverTrainer }"
                                        >
                                            Trainer
                                        </p>
                                    </div>
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverStreamer = true"
                                            @mouseleave="hoverStreamer = false"
                                            v-if="user.rola.indexOf('STREAMER') !== -1"
                                            src="../assets/roleIcons/streamer.svg"
                                            alt="streamer"
                                        />
                                        <p
                                            class="hover-text-icons-mobile"
                                            :class="{ 'hover-text-active': hoverStreamer }"
                                        >
                                            Streamer
                                        </p>
                                    </div>
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverChessbox = true"
                                            @mouseleave="hoverChessbox = false"
                                            v-if="user.rola.indexOf('CHESSBOXER') !== -1"
                                            src="../assets/roleIcons/chess-boxer.svg"
                                            alt="chess-boxer"
                                        />
                                        <p
                                            class="hover-text-icons-mobile"
                                            :class="{ 'hover-text-active': hoverChessbox }"
                                        >
                                            Chess Boxer
                                        </p>
                                    </div>
                                    <div style="position: relative">
                                        <img
                                            @mouseover="hoverOrganizer = true"
                                            @mouseleave="hoverOrganizer = false"
                                            v-if="user.rola.indexOf('ORGANIZER') !== -1"
                                            src="../assets/roleIcons/organizer.svg"
                                            alt="organizer"
                                        />
                                        <p
                                            class="hover-text-icons-mobile"
                                            :class="{ 'hover-text-active': hoverOrganizer }"
                                        >
                                            Organizer
                                        </p>
                                    </div>
                                </div>
                                <div class="profile-info1">
                                    <p class="info-par cursor-default">Age {{ user.godine }}</p>

                                    <div class="padd-text profile-info1-1">
                                        <div class="profile-info1-1 cursor-default">
                                            <img src="../assets/location-icon.svg" alt="location icon" />
                                            <p class="info-par">
                                                {{ user.city }}
                                            </p>
                                        </div>
                                    </div>

                                    <p style="color: #ffffff" class="padd-text info-par cursor-default">
                                        {{ user.sex }}
                                    </p>
                                </div>
                                <div class="profile-info1-1 flex-center-mobile">
                                    <div>
                                        <div style="display: flex; align-items: center !important">
                                            <p class="info-par federation cursor-default">Federation</p>
                                            <!--   {{ user.federation_details.name }}  -->
                                            <div class="federation2 flex-center">
                                                <v-app v-show="user.federation_details.code">
                                                    <div class="text-center d-flex ma-4 justify-center">
                                                        <v-tooltip dark bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                                                                    <img
                                                                        v-if="
                                                                            typeof user.federation_details.code ==
                                                                                'string' && user.federation !== 'FIDE'
                                                                        "
                                                                        :src="
                                                                            require('../assets/flags/' +
                                                                                user.federation_details.code
                                                                                    .toLowerCase()
                                                                                    .toString() +
                                                                                '.svg')
                                                                        "
                                                                        alt="flag"
                                                                    />
                                                                </v-btn>
                                                            </template>
                                                            <span v-if="user.federation !== 'FIDE'">{{
                                                                user.federation_details.name
                                                            }}</span>
                                                        </v-tooltip>
                                                    </div>
                                                </v-app>
                                                <div
                                                    class="text-center d-flex ma-4 justify-center"
                                                    style="margin-left: 6px; width: 2.95rem"
                                                >
                                                    <img
                                                        v-if="user.federation == 'FIDE'"
                                                        :src="require('@/assets/fide_flag.png')"
                                                        alt="flag"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p v-if="user.fide_id >= 0" class="info-par cursor-default">FIDE ID</p>
                                    <p v-else-if="user.uscf_id > 0" class="info-par cursor-default">USCF ID</p>
                                    <p v-else class="info-par cursor-default">FIDE ID</p>

                                    &nbsp;&nbsp;
                                    <div v-if="user.verified">
                                        <a
                                            v-if="user.uscf_id == null || user.uscf_id == '/'"
                                            :href="`https://ratings.fide.com/profile/` + user.fide_id"
                                            target="_blank"
                                            >{{ user.fide_id }}
                                        </a>
                                        <a
                                            :href="`https://www.uschess.org/msa/MbrDtlMain.php?` + user.uscf_id"
                                            v-else-if="user.fide_id == null || user.fide_id == '/'"
                                            class="info-par fide-id cursor-default"
                                        >
                                            {{ user.uscf_id }}
                                        </a>
                                        <a
                                            v-else
                                            class="info-par fide-id cursor-default"
                                            :href="`https://ratings.fide.com/profile/` + user.fide_id"
                                        >
                                            {{ user.fide_id }}
                                        </a>
                                    </div>
                                    <!-- class="id-number" -->
                                    <div v-else>
                                        <a
                                            v-if="user.uscf_id == null || user.uscf_id == '/'"
                                            class="info-par fide-id"
                                            :href="`https://ratings.fide.com/profile/` + user.fide_id"
                                            target="_blank"
                                        >
                                            {{ user.fide_id }}
                                        </a>
                                        <a
                                            :href="`https://www.uschess.org/msa/MbrDtlMain.php?` + user.uscf_id"
                                            v-else-if="user.fide_id == null || user.fide_id == '/'"
                                            class="info-par fide-id cursor-default"
                                        >
                                            {{ user.uscf_id }}
                                        </a>
                                        <a
                                            v-else
                                            class="info-par fide-id cursor-default"
                                            :href="`https://ratings.fide.com/profile/` + user.fide_id"
                                        >
                                            {{ user.fide_id }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="public-center-right"
                                :class="{
                                    'no-margin':
                                        user.is_work_days_lesson_set == false && user.is_work_days_linkup_set == false,
                                }"
                            >
                                <div class="public-center-right-div">
                                    <div
                                        v-if="user.is_work_days_lesson_set == true"
                                        class="color-button color-button-learn"
                                        @click="openLessonPicker"
                                    >
                                        <img src="@/assets/publicProfile_icons/learn.svg" alt="" />
                                        <p class="sm-hide">LESSON</p>
                                        <p class="sm-show">Lesson</p>
                                    </div>
                                    <div
                                        @click="openLinkupPicker"
                                        v-if="user.is_work_days_linkup_set == true"
                                        class="color-button color-button-link"
                                    >
                                        <img src="@/assets/publicProfile_icons/linkup.svg" alt="" />
                                        <p class="sm-hide no-wrap">LINK-UP</p>
                                        <p class="sm-show">Link-up</p>
                                    </div>
                                    <div
                                        v-if="
                                            user.user_uuid !== 'e0caf20e-5e6f-11ed-b904-7ee1ac15c117' &&
                                            user.user_uuid !== 'ecdc7112-00bb-11f0-abdc-daa9348bd96f' &&
                                            user.user_uuid !== '0c6b9166-00bc-11f0-91e3-daa9348bd96f' &&
                                            user.user_uuid !== '1651dfdc-00bc-11f0-b514-daa9348bd96f' &&
                                            user.user_uuid !== '1c116a28-00bc-11f0-b514-daa9348bd96f' &&
                                            user.user_uuid !== '219e1202-00bc-11f0-b514-daa9348bd96f' &&
                                            user.user_uuid !== '2778f0b6-00bc-11f0-b514-daa9348bd96f' &&
                                            user.disabled_notif.challenge_me !== true &&
                                            !user.blocked_me
                                        "
                                        id="checkClickChallenge2"
                                        @click="openChallengeForm"
                                        class="color-button color-button-match"
                                    >
                                        <img src="@/assets/publicProfile_icons/match.svg" alt="" />
                                        <p class="sm-hide">CHALLENGE</p>
                                        <p class="sm-show">Challenge</p>
                                    </div>
                                </div>
                                <div
                                    class="public-profile-right"
                                    v-if="
                                        logedIn &&
                                        user.user_uuid !== 'ecdc7112-00bb-11f0-abdc-daa9348bd96f' &&
                                        user.user_uuid !== '0c6b9166-00bc-11f0-91e3-daa9348bd96f' &&
                                        user.user_uuid !== '1651dfdc-00bc-11f0-b514-daa9348bd96f' &&
                                        user.user_uuid !== '1c116a28-00bc-11f0-b514-daa9348bd96f' &&
                                        user.user_uuid !== '219e1202-00bc-11f0-b514-daa9348bd96f' &&
                                        user.user_uuid !== '2778f0b6-00bc-11f0-b514-daa9348bd96f'
                                    "
                                >
                                    <div class="middle2-1-button-container">
                                        <div
                                            @mouseover="hoverFollow = true"
                                            @mouseleave="hoverFollow = false"
                                            v-if="$store.state.listFollowingUuid.indexOf(idt) == -1 && unfollowed"
                                            :class="{
                                                //'follow-desktop-active': $store.state.listFollowingUuid.indexOf(idt) !== -1,
                                                opacity1: connecting_initiation == true,
                                            }"
                                            class="pay-desktop follow-desktop flex-center"
                                            @click="connection_initiate"
                                        >
                                            <img src="@/assets/publicProfile_icons/follow.svg" alt="" />
                                            <p class="hover-text" :class="{ 'hover-text-active': hoverFollow }">
                                                Follow {{ user.name_first }}
                                            </p>
                                        </div>

                                        <div
                                            :class="{
                                                'follow-desktop-active':
                                                    $store.state.listFollowingUuid.indexOf(idt) == -1,
                                                opacity1: connecting_initiation == true,
                                            }"
                                        >
                                            <div
                                                @click="unfollow"
                                                @mouseover="hoverUnfollow = true"
                                                @mouseleave="hoverUnfollow = false"
                                                class="pay-desktop follow-desktop flex-center"
                                                v-if="
                                                    $store.state.listFollowingUuid.indexOf(idt) !== -1 &&
                                                    deleteConnectionButton
                                                "
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    height="17"
                                                    fill="#DADADA"
                                                    viewBox="0 -960 960 960"
                                                    width="17"
                                                >
                                                    <path
                                                        d="M702-480 560-622l57-56 85 85 170-170 56 57-226 226Zm-342 0q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 260Zm0-340Z"
                                                    />
                                                </svg>
                                                <p class="hover-text" :class="{ 'hover-text-active': hoverUnfollow }">
                                                    Unfollow {{ user.name_first }}?
                                                </p>
                                            </div>

                                            <!-- <p
                                        class="unfollow-button follow-desktop flex-center"
                                        @mouseleave="removeButtonUnfollow"
                                        v-if="!deleteConnectionButton && unfollowButton"
                                        @click="unfollow"
                                    >
                                        UNFOLLOW?
                                    </p> -->
                                        </div>
                                        <router-link
                                            style="opacity: 1 !important"
                                            :user_uuid="idt"
                                            :to="{ name: 'ChatInner', params: { id: idt } }"
                                        >
                                            <div
                                                @mouseover="hoverMessage = true"
                                                @mouseleave="hoverMessage = false"
                                                class="message-desktop message-div flex-center"
                                            >
                                                <img src="@/assets/publicProfile_icons/message.svg" alt="" />
                                                <!-- <p class="hover-text2" :class="{'hover-text-active2':hoverMessage}" >  Message </p>   -->
                                            </div>
                                        </router-link>

                                        <div
                                            @mouseover="hoverPay = true"
                                            @mouseleave="hoverPay = false"
                                            class="pay-desktop flex-center"
                                            @click="payUser"
                                        >
                                            <img src="@/assets/publicProfile_icons/pay.svg" alt="" />
                                            <p class="hover-text" :class="{ 'hover-text-active': hoverPay }">
                                                Pay {{ user.name_first }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="public-follow">
                                        <!--     <FollowProfileNum />  -->
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-if="logedIn" class="middle2-button-container">
                            <div @click="payUser" class="pay-message flex-center">
                                <svg
                                    width="23"
                                    height="17"
                                    viewBox="0 0 23 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.4434 9.27209C12.61 9.27209 11.9017 8.98043 11.3184 8.39709C10.735 7.81376 10.4434 7.10543 10.4434 6.27209C10.4434 5.43876 10.735 4.73043 11.3184 4.14709C11.9017 3.56376 12.61 3.27209 13.4434 3.27209C14.2767 3.27209 14.985 3.56376 15.5684 4.14709C16.1517 4.73043 16.4434 5.43876 16.4434 6.27209C16.4434 7.10543 16.1517 7.81376 15.5684 8.39709C14.985 8.98043 14.2767 9.27209 13.4434 9.27209ZM6.44336 12.2721C5.89336 12.2721 5.42269 12.0761 5.03136 11.6841C4.63936 11.2928 4.44336 10.8221 4.44336 10.2721V2.27209C4.44336 1.72209 4.63936 1.25143 5.03136 0.860095C5.42269 0.468095 5.89336 0.272095 6.44336 0.272095H20.4434C20.9934 0.272095 21.4644 0.468095 21.8564 0.860095C22.2477 1.25143 22.4434 1.72209 22.4434 2.27209V10.2721C22.4434 10.8221 22.2477 11.2928 21.8564 11.6841C21.4644 12.0761 20.9934 12.2721 20.4434 12.2721H6.44336ZM8.44336 10.2721H18.4434C18.4434 9.72209 18.639 9.25109 19.0304 8.85909C19.4224 8.46776 19.8934 8.27209 20.4434 8.27209V4.27209C19.8934 4.27209 19.4224 4.07609 19.0304 3.68409C18.639 3.29276 18.4434 2.82209 18.4434 2.27209H8.44336C8.44336 2.82209 8.24736 3.29276 7.85536 3.68409C7.46403 4.07609 6.99336 4.27209 6.44336 4.27209V8.27209C6.99336 8.27209 7.46403 8.46776 7.85536 8.85909C8.24736 9.25109 8.44336 9.72209 8.44336 10.2721ZM19.4434 16.2721H2.44336C1.89336 16.2721 1.42269 16.0764 1.03136 15.6851C0.639359 15.2931 0.443359 14.8221 0.443359 14.2721V3.27209H2.44336V14.2721H19.4434V16.2721Z"
                                        fill="#FFC695"
                                    />
                                </svg>
                                <p>Pay</p>
                            </div>

                            <router-link :user_uuid="idt" :to="{ name: 'ChatInner', params: { id: idt } }">
                                <div class="pay-message flex-center">
                                    <svg
                                        width="14"
                                        height="13"
                                        viewBox="0 0 14 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.7959 7.89709H8.0459V7.14709H2.7959V7.89709ZM2.7959 5.64709H11.0459V4.89709H2.7959V5.64709ZM2.7959 3.39709H11.0459V2.64709H2.7959V3.39709ZM0.170898 12.8283V1.24084C0.170898 0.890845 0.286648 0.600095 0.518148 0.368595C0.749148 0.137595 1.03965 0.0220947 1.38965 0.0220947H12.4521C12.8021 0.0220947 13.0929 0.137595 13.3244 0.368595C13.5554 0.600095 13.6709 0.890845 13.6709 1.24084V9.30334C13.6709 9.65335 13.5554 9.94409 13.3244 10.1756C13.0929 10.4066 12.8021 10.5221 12.4521 10.5221H2.47715L0.170898 12.8283ZM0.920898 11.0096L2.1584 9.77209H12.4521C12.5896 9.77209 12.7021 9.72834 12.7896 9.64084C12.8771 9.55334 12.9209 9.44084 12.9209 9.30334V1.24084C12.9209 1.10334 12.8771 0.990845 12.7896 0.903345C12.7021 0.815845 12.5896 0.772095 12.4521 0.772095H1.38965C1.25215 0.772095 1.13965 0.815845 1.05215 0.903345C0.964649 0.990845 0.920898 1.10334 0.920898 1.24084V11.0096ZM0.920898 1.24084V0.772095V11.0096V1.24084Z"
                                            fill="#FFC695"
                                        />
                                    </svg>
                                    <p>Message</p>
                                </div>
                            </router-link>
                        </div> -->
                        </div>
                    </div>
                    <!--END MID 2   -->
                    <!--MID 3 -->
                    <div :class="{ shadow: popupChallenge }" class="menu-container">
                        <!-- <div  @click="menuClick('bioActive')" class="menu" :class="{'menu-active':bioActive}">Biography</div> -->
                        <div
                            @click="menuClick('bioActive')"
                            class="menu"
                            :class="{
                                'menu-active': bioActive,
                                inactive: this.user.about_me == null || this.user.about_me == undefined,
                            }"
                        >
                            Biography
                        </div>

                        <div
                            @click="menuClick('titActive')"
                            class="menu"
                            :class="{
                                'menu-active': titActive,
                                inactive:
                                    user.titula_arbiter == null &&
                                    user.titula_organizer == null &&
                                    user.titula_player == null &&
                                    user.titula_trainer == null,
                            }"
                        >
                            Title
                        </div>
                        <div
                            @click="menuClick('ratActive')"
                            class="menu"
                            :class="{
                                'menu-active': ratActive,
                                inactive:
                                    user.rating_standard == null &&
                                    user.rating_rapid == null &&
                                    user.rating_blitz == null,
                            }"
                        >
                            Rating
                        </div>
                        <div
                            @click="menuClick('bloActive')"
                            class="menu"
                            :class="{ 'menu-active': bloActive, inactive: this.my_blogs.length == 0 }"
                        >
                            My Blog
                        </div>
                    </div>
                    <div
                        id="middle3"
                        :class="{
                            shadow: popupChallenge,
                            'middle3-height':
                                user.titula_arbiter == null &&
                                user.titula_organizer == null &&
                                user.titula_player == null &&
                                user.titula_trainer == null,
                            'middle3-height-zero': mobileScreen && !ratActive && !titActive && !bioActive && !bloActive,
                        }"
                    >
                        <div
                            v-if="!mobileScreen || (mobileScreen && titActive)"
                            class="middle3-1 middle3-1-title"
                            :class="{
                                'no-title-mobile':
                                    user.titula_arbiter == null &&
                                    user.titula_organizer == null &&
                                    user.titula_player == null &&
                                    user.titula_trainer == null,
                            }"
                        >
                            <div class="middle3-1-1">
                                <p class="info-par" style="color: #6f7381; margin: auto 0">Title:</p>
                                <div style="display: flex">
                                    <div v-if="user.titula_player !== null" class="titles">
                                        {{ user.titula_player_details.titula_short_name }}
                                        <!-- <img class="title-arrow" src="../assets/arrow_down.png" alt="">  -->
                                    </div>

                                    <div
                                        v-if="
                                            user.titula_organizer !== null && this.user.rola.indexOf('ORGANIZER') !== -1
                                        "
                                        class="titles"
                                    >
                                        IO
                                        <!-- <img class="title-arrow" src="../assets/arrow_down.png" alt="">  -->
                                    </div>
                                    <div
                                        v-if="user.titula_trainer !== null && this.user.rola.indexOf('TRAINER') !== -1"
                                        class="titles"
                                    >
                                        {{ user.titula_trainer_details.titula_short_name }}
                                        <!-- <img class="title-arrow" src="../assets/arrow_down.png" alt="">  -->
                                    </div>
                                    <div
                                        v-if="user.titula_arbiter !== null && this.user.rola.indexOf('ARBITER') !== -1"
                                        class="titles"
                                    >
                                        {{ user.titula_arbiter_details.titula_short_name }}
                                        <!-- <img class="title-arrow" src="../assets/arrow_down.png" alt="">  -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!mobileScreen || (mobileScreen && ratActive)" class="middle3-1">
                            <p class="rating info-par cursor-default" style="color: #6f7381">Rating:</p>
                            <div class="ratings">
                                <p class="text-ratings">Standard:</p>
                                <p v-if="user.rating_standard == 0">/</p>
                                <p v-else>
                                    {{ user.rating_standard }}
                                </p>
                            </div>
                            <div class="ratings">
                                <p class="text-ratings">Rapid:</p>
                                <p v-if="user.rating_rapid == 0">/</p>
                                <p v-else>
                                    {{ user.rating_rapid }}
                                </p>
                            </div>
                            <div class="ratings">
                                <p class="text-ratings">Blitz:</p>
                                <p v-if="user.rating_blitz == 0">/</p>
                                <p v-else>
                                    {{ user.rating_blitz }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="bioActive && markdownContent !== null && markdownContent !== undefined"
                        class="biography middle3-1 no-desktop"
                        :class="{
                            shadow: popupChallenge,
                            'biography-height-zero': mobileScreen && !bioActive && !bloActive,
                            'biography-height-final': mobileScreen && bioActive,
                        }"
                    >
                        <div class="top">
                            <p>Biography</p>
                        </div>
                        <div class="bottom">
                            <p style="white-space: pre-line" v-html="markdownContent" />
                        </div>
                    </div>

                    <div
                        v-if="my_blogs.length > 0 && bloActive"
                        class="biography middle3-1-blog"
                        style="word-wrap: break-word"
                    >
                        <div class="top">
                            <!-- <p>My Blog</p>

                            <img
                                id="arrow2"
                                :class="{
                                    'arrow-active': blogUser,
                                }"
                                src="../assets/Profile/arrow-forward.svg"
                                alt="arrow forward"
                                @click="blogUser = !blogUser"
                            /> -->
                        </div>

                        <div class="bottom">
                            <BlogUser :key="user.user_uuid" :user="user" @popUp="popUp" @popupAdd="popupAdd" />
                        </div>
                    </div>

                    <div
                        id="calendar"
                        v-show="calendarEntry || !showCalendar"
                        class="biography bio-calendar"
                        style="word-wrap: break-word"
                    >
                        <div class="top">
                            <p>Calendar</p>

                            <img
                                class="arrow-calednar"
                                id="arrow2"
                                :class="{
                                    'arrow-active': calendarUser,
                                }"
                                src="../assets/Profile/arrow-forward.svg"
                                alt="arrow forward"
                                @click="calendarUser = !calendarUser"
                            />
                        </div>

                        <div v-if="calendarUser" class="bottom bottom-calendar">
                            <CalendarDatePicker
                                :trainerData="trainerData"
                                :user="user"
                                @scroll="scroll"
                                :userTrainer="user.user_uuid"
                            />
                        </div>
                    </div>

                    <!--MIDDLE 4 -->
                    <div id="middle4">
                        <div class="middle3-1 sm-hide middle3-1a">
                            <div style="margin-left: 1.875rem">
                                <p
                                    :class="{ 'middle4-1': isActive, ratingsi: clickActive1 }"
                                    @click="cvdairycal('clickActive1')"
                                >
                                    BIOGRAPHY
                                </p>
                            </div>
                            <div>
                                <p
                                    v-if="my_blogs.length > 0"
                                    :class="{ 'middle4-1': isActive, ratingsi: clickActive2 }"
                                    @click="cvdairycal('clickActive2')"
                                >
                                    MY BLOG
                                </p>
                            </div>
                            <div>
                                <p
                                    v-if="calendarEntry"
                                    :class="{ 'middle4-1': isActive, ratingsi: clickActive3 }"
                                    @click="cvdairycal('clickActive3')"
                                >
                                    CALENDAR
                                </p>
                            </div>
                        </div>
                        <div class="middle3-1 roles">
                            <div
                                v-if="user.rola.indexOf('PLAYER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor1 }"
                                @click="role_indicator(1)"
                            >
                                Player
                            </div>
                            <div
                                v-if="user.rola.indexOf('CLUBADMIN') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor2 }"
                                @click="role_indicator(2)"
                            >
                                Club Admin
                            </div>
                            <div
                                v-if="user.rola.indexOf('ORGANIZER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor3 }"
                                @click="role_indicator(3)"
                            >
                                Organizer
                            </div>
                            <div
                                v-if="user.rola.indexOf('ARBITER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor4 }"
                                @click="role_indicator(5)"
                            >
                                Arbiter
                            </div>
                            <div
                                v-if="user.rola.indexOf('TRAINER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor5 }"
                                @click="role_indicator(4)"
                            >
                                Trainer
                            </div>
                            <div
                                v-if="user.rola.indexOf('OTHER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor6 }"
                                @click="role_indicator(6)"
                            >
                                Other
                            </div>
                            <div
                                v-if="user.rola.indexOf('STREAMER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor7 }"
                                @click="role_indicator(7)"
                            >
                                Streamer
                            </div>
                            <div
                                v-if="user.rola.indexOf('CHESSBOXER') !== -1"
                                :class="{ 'middle4-1': isActive, 'rola-text': rolecolor8 }"
                                @click="role_indicator(8)"
                                style="white-space: nowrap"
                            >
                                Chess Boxer
                            </div>
                        </div>
                    </div>

                    <!--END MIDDLE 4 -->

                    <!--MIDDLE 5 -->
                    <div :class="{ shadow: popupChallenge }" id="middle5">
                        <div class="middle5-left">
                            <div v-if="clickActive1">
                                <BiographyPublic :key="user.user_uuid" :user="user" />
                            </div>
                            <div v-if="clickActive2">
                                <BlogUser :key="user.user_uuid" :user="user" @popUp="popUp" @popupAdd="popupAdd" />
                            </div>
                            <div v-if="clickActive3">
                                <CalendarDatePicker
                                    :user="user"
                                    :trainerData="trainerData"
                                    :userTrainer="user.user_uuid"
                                />
                            </div>
                        </div>

                        <div class="main-right">
                            <!--PLAYER PART -->
                            <div v-if="activePlayer && user.rola.indexOf('PLAYER') !== -1">
                                <PublicPlayer :user="user" />
                            </div>
                            <!-- END PLAYER PART  -->
                            <!-- CLUB PART  -->
                            <div v-else-if="activeClub && user.rola.indexOf('CLUB') !== -1">
                                <PublicClub :user="user" />
                            </div>
                            <!--END CLUB PART  -->
                            <!-- ORGANIZER PART  -->
                            <div v-else-if="activeOrg && this.user.rola.indexOf('ORGANIZER') !== -1">
                                <PublicOrganizer :user="user" />
                            </div>
                            <!-- Trainer -->
                            <div v-else-if="activeTre && user.rola.indexOf('TRAINER') !== -1">
                                <PublicTrainer
                                    :user="user"
                                    :trainerData="trainerData"
                                    @openLessonPicker="openLessonPicker"
                                    :calendarUser="calendarUser"
                                />
                            </div>

                            <!-- Arbiter -->
                            <div v-else-if="activeArb && this.user.rola.indexOf('ARBITER') !== -1">
                                <PublicArbiter :user="user" />
                            </div>
                            <!-- Other -->
                            <div v-else-if="activeOth && user.rola.indexOf('OTHER') !== -1">
                                <PublicOther :user="user" />
                            </div>
                            <div v-else-if="activeStr && user.rola.indexOf('STREAMER') !== -1">
                                <PublicStreamer :user="user" />
                            </div>
                            <div v-else-if="activeBox && user.rola.indexOf('CHESSBOXER') !== -1">
                                <PublicChessBoxer :user="user" />
                            </div>
                        </div>
                    </div>
                </div>
                <!--        </div>-->
            </div>
        </div>
        <!--END  RIGHT PROFILE -->
        <div class="footer_mobile">
            <ChatroomFooter />
        </div>
    </div>
</template>

<script>
import DOMPurify from "dompurify";
import { marked } from "marked";
import BlogUser from "@/components/left-profile/BlogUser.vue";
import SideBar from "@/components/SideBar.vue";
import Loader from "@/components/Loader.vue";

//import Searchpart from "../components/Searchpart.vue";
import BiographyPublic from "../components/left-profile/BiographyPublic.vue";
//import Calendar from "@/components/left-profile/Calendar.vue";
import ChatroomFooter from "@/components/Chatroom/ChatroomFooter.vue";
//import Notification from '../utils/notification.js'
import Search from "@/components/Search.vue";
import Notifications from "@/components/Notification/Notifications.vue";
//import socketUtil from "../socket";
import MobileHeader from "@/components/MobileHeader.vue";
import { fetchBadges } from "../utils/fetchProfile";
import PublicPlayer from "@/components/Right-publicprofile/PublicPlayer.vue";
import BlogCard from "@/components/Blog/BlogCard.vue";

//import FollowProfileNum from "@/components/Follow/FollowProfileNum.vue";

export default {
    name: "PublicProfile",

    components: {
        SideBar,
        BlogCard,
        Search,
        //  Calendar,
        Notifications,
        BiographyPublic,
        Loader,
        ChatroomFooter,
        MobileHeader,
        PublicPlayer,
        BlogUser,
        PublicClub: () => import("@/components/Right-publicprofile/PublicClub.vue"),
        PublicOrganizer: () => import("@/components/Right-publicprofile/PublicOrganizer.vue"),
        PublicOther: () => import("@/components/Right-publicprofile/PublicOther.vue"),
        PublicTrainer: () => import("@/components/Right-publicprofile/PublicTrainer.vue"),
        PublicArbiter: () => import("@/components/Right-publicprofile/PublicArbiter.vue"),
        PublicStreamer: () => import("@/components/Right-publicprofile/PublicStreamer.vue"),
        PublicChessBoxer: () => import("@/components/Right-publicprofile/PublicChessBoxer.vue"),
        FollowButtonMobile: () => import("@/components/Follow/FollowButtonMobile.vue"),
        MessageButtonMobile: () => import("@/components/Follow/MessageButtonMobile.vue"),

        PayButtonMobile: () => import("@/components/Follow/PayButtonMobile.vue"),
        CalendarDatePicker: () => import("@/components/left-profile/Public/CalendarDatePicker.vue"),
        ChallengeForm: () => import("@/components/Gamer/ChallengeForm.vue"),
        BlockUser: () => import("@/components/Profile/BlockUser.vue"),
        BlockForm: () => import("@/components/Profile/BlockForm.vue"),

        //FollowProfileNum,
    },
    props: ["user_uuid", "id"],
    //  props:{
    //    id_user:String
    //    },
    data() {
        return {
            shadow: false,
            isSidebarOpen: false,
            isActive: true,
            clickActive1: true,
            clickActive2: "",
            clickActive3: "",
            nl: "",
            nf: "",
            use: "",
            isActive2: true,
            rapid: "",
            standard: "",
            blitz: "",
            curclub: "",
            curleague: "",
            curplay: "",
            curevent: "",
            town: "",
            fideid: "",
            curclubname1: "",
            curleagueclub1: "",
            curplayclub1: "",
            birtyear: "",
            about: "",
            flags: [],
            fla: "",
            selected: "",
            selectedrole: "",
            selectedFile: null,
            formData: "",
            newFormData: "",
            userroles: "",
            rolecolor1: false,
            rolecolor2: false,
            rolecolor3: false,
            rolecolor4: false,
            rolecolor5: false,
            rolecolor6: false,
            rolecolor7: false,
            rolecolor8: false,
            activePlayer: false,
            activeClub: false,
            activeOrg: false,
            activeArb: false,
            activeTre: false,
            activeOth: false,
            activeStr: false,
            activeBox: false,
            switch1: "",
            switch2: "",
            showCalendar: "",
            calendarUser: false,
            user: {
                rola: [],
                user_uuid: "",
                federation_details: {},
                rola_array: [],
                comp_per_game_from: "",
                comp_per_game_to: "",
                profile: [],
                cv: {},
                open2new_eng_club: "",
                open2new_eng_event: "",
                open2new_eng_tournament: "",
                club_looking_for_new_player: "",
                organizer_looking_for_new_participants: "",
            },

            sexon: "",
            picked: "",
            pickedorg: "",
            switch3: "",
            switch5: "",
            createevent: "",

            my_interested_list: [],
            my_intclub_list: [],
            my_int_trainer_list: [],
            my_int_arbiter_list: [],
            listpla: { target_uuid: "" },
            hoverArbiter: false,
            notif_arr: [],
            connecting_initiation: false,
            my_connection_list: [],
            price_entered: true,
            blogView: false,
            blogUser: false,
            my_blogs: [],
            snackbarPay: false,
            textTransaction: "Soon, you’ll have the option to pay through us, stay there! :) ",
            newConnection: [],
            deleteConnectionButton: true,
            showFollowList: false,
            unfollowed: true,
            unfollowButton: false,
            logedIn: false,
            trainerData: [],
            calendarEntry: false,
            hoverFollow: false,
            hoverMessage: false,
            hoverPay: false,
            hoverUnfollow: false,
            bloActive: false,
            titActive: false,
            ratActive: false,
            bioActive: false,
            mobileScreen: false,
            linkupRoute: "",
            hoverPlayer: false,
            hoverClub: false,
            hoverTrainer: false,
            hoverStreamer: false,
            hoverChessbox: false,
            hoverOrganizer: false,
            popupChallenge: false,
            interestedInfo: {},
            loader: false,
            badges: [],
            openPopupBlockDiv: false,
            changeBlockUser: false,
        };
    },

    computed: {
        markdownContent() {
            if (this.user.about_me !== null && this.user.about_me !== undefined) {
                return DOMPurify.sanitize(marked.parse(this.user.about_me));
            } else {
                return "";
            }
        },
    },
    watch: {
        //  openPopupBlockDiv(e) {
        //     if (e) {
        //     }
        // },
        // popupChallenge(e) {
        //     if (e) {
        //         document.addEventListener("click", this.closeIfClickedOutside);
        //     }
        // }
    },
    async created() {
        this.loader = true;
        this.idt = this.$route.params.id;

        this.linkupRoute = this.$route.params.plan;
        //   console.log(this.linkupRoute);
        this.logedIn = localStorage.getItem("id");
        if (this.idt == this.logedIn) {
            this.$router.push({ name: "Profile", params: { id: this.logedIn } });
        }

        // await fetch(process.env.VUE_APP_URL + `public_user_info/${this.idt} `, {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        // })
        //     .then(response => response.json())
        //     .then(data => (this.user = data))
        //        .then(data => console.log("public", data))
        //     .then(this.checkRole);
        if (this.logedIn) {
            await fetch(process.env.VUE_APP_URL + `user_info_v2/${this.idt} `, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())

                .then(data => (this.interestedInfo = data))
                .then(data => (this.user = data.info))

                //  .then(data => console.log("public_v2", data))

                .then(this.checkRole)
                .then(this.badgesGo);
        } else {
            await fetch(process.env.VUE_APP_URL + `user_info_v2/${this.idt} `, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => (this.interestedInfo = data))
                .then(data => (this.user = data.info))
                .then(this.checkRole)
                .then(this.badgesGo);
        }
    },
    mounted() {
        if (screen.width < 640) {
            this.mobileScreen = true;
        }

        // fetch(process.env.VUE_APP_URL + "/current_user_info", {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json",
        //         authorization: `Bearer ${localStorage.getItem("token")}`,
        //     },
        // })
        //     .then(response => response.json())
        //     .then(data => (this.userinitiator = data));

        //.then(data => console.log('initiator',data))
        fetch(process.env.VUE_APP_URL + `/blog_posts_by_user/${this.idt} `, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => (this.my_blogs = data));

        // fetch(process.env.VUE_APP_URL + "/interested_in_arbiter", {
        //     method: "GET",
        //     headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
        // })
        //     .then(response => response.json())
        //     .then(data => (this.my_int_arbiter_list = data));

        // fetch(process.env.VUE_APP_URL + "/interested_in_trainer", {
        //     method: "GET",
        //     headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
        // })
        //     .then(response => response.json())
        //     .then(data => (this.my_int_trainer_list = data));

        setTimeout(() => {
            this.loadFollow();
        }, 800);
    },

    //--------------METHODS----------------------//

    methods: {
        blockChange() {
            this.changeBlockUser = true;
        },
        async badgesGo() {
            try {
                this.badges = await fetchBadges(this.user.user_uuid);
            } catch (err) {
                this.error = "Failed to load data";
            } finally {
                this.loader = false;
                this.$store.commit("SET_BADGES_OTHER", this.badges);
            }
        },
        openPopupBlock() {
            this.openPopupBlockDiv = true;
            setTimeout(() => {
                document.addEventListener("click", this.closeIfClickedOutsideBlock);
            }, 1000);
        },
        questionRoullette(e) {
            this.shadow = e;
        },
        // closeIfClickedOutside(event) {
        //     if (
        //         !document.getElementById("checkClickChallenge2")?.contains(event.target) &&  !document.getElementById("checkClickChallenge")?.contains(event.target)
        //     ) {

        //           console.log("outside",this.popupChallenge );
        //         this.popupChallenge = false;

        //     }
        // },
        popupChallangeClose() {
            this.popupChallenge = false;
        },
        closeIfClickedOutsideBlock(event) {
            // console.log('target',event.target)
            // console.log('target',!document.getElementById("block-form")?.contains(event.target))
            // console.log('target',!document.getElementById("block-dots")?.contains(event.target) )
            // console.log('target',!document.getElementById("checkBlockUser")?.contains(event.target))
            // console.log('target',!document.getElementById("block-svg")?.contains(event.target) )
            if (
                !document.getElementById("block-form")?.contains(event.target) &&
                !document.getElementById("block-dots")?.contains(event.target) &&
                !document.getElementById("checkBlockUser")?.contains(event.target) &&
                !document.getElementById("block-svg")?.contains(event.target)
            ) {
                //  console.log("outside block");
                this.openPopupBlockDiv = false;
                document.removeEventListener("click", this.closeIfClickedOutsideBlock);

                if (this.changeBlockUser) {
                    this.refreshUser();
                }
            }
        },
        blockClose() {
            this.openPopupBlockDiv = false;
            document.removeEventListener("click", this.closeIfClickedOutsideBlock);
        },
        refreshUser() {
            console.log("refresh");
            fetch(process.env.VUE_APP_URL + `user_info_v2/${this.idt} `, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())

                .then(data => (this.interestedInfo = data))
                .then(data => (this.user = data.info));
        },
        openChallengeForm() {
            this.popupChallenge = true;
        },
        challange(e) {
            //   this.challengeFinnish = false;
            this.popupChallenge = true;
            this.challangeUser = e;
            if (this.wallet_sum == "") {
                setTimeout(() => {
                    this.walletServis;
                }, 1000);
            }
        },
        walletServis() {
            fetch(process.env.VUE_APP_URL + "wallet_sum", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())
                .then(data => (this.wallet_sum = data));
            // .then(data => console.log("wallet_sum", data.total));
        },

        menuClick(e) {
            if (e == "bioActive" && (this.user.about_me == null || this.user.about_me == undefined)) {
                return;
            }
            if (
                e == "ratActive" &&
                this.user.rating_blitz == null &&
                this.user.rating_rapid == null &&
                this.user.rating_standard == null
            ) {
                return;
            }
            if (
                e == "titActive" &&
                this.user.titula_arbiter == null &&
                this.user.titula_organizer == null &&
                this.user.titula_player == null &&
                this.user.titula_trainer == null
            ) {
                return;
            }
            if (e == "bloActive" && this.my_blogs.length == 0) {
                return;
            }

            //   console.log(e);
            this.bloActive = false;
            this.titActive = false;
            this.ratActive = false;
            this.bioActive = false;
            this[e] = true;
        },
        openLessonPicker() {
            if (window.innerWidth < 500) {
                this.clickActive3 = false;
                this.calendarUser = false;
            } else {
                this.clickActive3 = true;
            }
            // console.log('cekerica', this.clickActive3)
            this.clickActive1 = false;
            this.clickActive2 = false;
            this.openLinkupPicker();
        },
        changePopup() {
            this.popupChallenge = false;
            //   console.log("kikiriki");
        },
        removeButtonUnfollow() {
            setTimeout(() => {
                this.remove();
            }, 3000);
        },
        remove() {
            this.deleteConnectionButton = true;
        },
        loadFollow() {
            // console.log('show',this.showFollowList)

            // connecting_initiation == false && showFollowList == true &&
            //                                     showFollowList == true) || unfollowed
            //  console.log(this.$store.state.listFollowingUuid)
            if (this.$store.state.listFollowingUuid.indexOf(this.idt) !== -1) {
                this.connecting_initiation = true;
                this.showFollowList = true;
            } else {
                this.showFollowList = true;
            }
        },
        unfollow() {
            this.deleteConnectionButton = true;
            this.unfollowed = true;
            fetch(process.env.VUE_APP_URL + `/connection_initiator_delete/${this.idt} `, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: null,
            })
                .then(response => response.json())
                // .then(data => console.log("brisanje", data))
                .catch(error => {
                    console.error(error);
                });
            this.$store.commit("DELETE_FOLLOWING", this.idt);
            // this.unfollowed = true;
            // this.connecting_initiation = false;
            // this.showFollowList = true;
            // this.deleteConnectionButton = false;
        },
        popUp(e, index) {
            this.blogView = true;
            if (e) {
                this.blog = e;
                this.blogNumber = index;
            }
        },
        popupAdd() {
            this.blogAdd = true;
        },
        noPopup() {
            this.blogView = false;
            this.blogAdd = false;
        },
        clickCounter() {
            // console.log(this.$store.state.current_user.email);
            let linkupClick = true;
            let email = this.$store.state.current_user.email;
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "qfb2wowv",
                email: email, // Email address,
                user_hash: localStorage.getItem("H"),
                LinkupClick: linkupClick,
            });
        },
        removingQuestButton() {
            this.deleteConnectionButton = false;
            this.unfollowButton = true;
        },
        payUser() {
            this.$router.push({
                path: "/wallet",
                query: {
                    plan: "sendActive",
                    route: this.user.user_uuid,
                    first: this.user.name_first,
                    last: this.user.name_last,
                    fide: this.user.fide_id,
                    pic: this.user.profile.file_url,
                },
            });
        },

        checkRole() {
            //console.log("provera", this.interestedInfo);
            this.$store.commit("SET_INT_PLAYER", this.interestedInfo.interested_in_player);
            this.$store.commit("SET_INT_CLUB", this.interestedInfo.interested_in_club);
            if (
                this.user.titula_arbiter !== null ||
                this.user.titula_organizer !== null ||
                this.user.titula_player !== null ||
                this.user.titula_trainer !== null
            ) {
                this.titActive = true;
            } else if (
                this.user.rating_standard !== null ||
                this.user.rating_rapid !== null ||
                this.user.rating_blitz !== null
            ) {
                this.ratActive = true;
            } else if (this.user.about_me !== null && this.user.about_me !== undefined) {
                this.bioActive = true;
            }
            if (
                this.user.time_zone !== null &&
                this.user.time_zone !== undefined &&
                this.user.time_zone !== "" &&
                ((this.user.trainer_price_lesson !== null &&
                    this.user.trainer_price_lesson !== undefined &&
                    this.user.trainer_price_lesson !== "") ||
                    (this.user.trainer_price_linkup !== null &&
                        this.user.trainer_price_linkup !== undefined &&
                        this.user.trainer_price_linkup !== ""))
            ) {
                this.clickActive3 = true;
                this.clickActive1 = false;
                this.clickActive2 = false;
            }

            if (
                (this.user.time_zone !== null && this.user.time_zone !== null && this.user.time_zone !== null) ||
                this.user.rola.indexOf("PLAYER") !== -1
            ) {
                this.calendarEntry = true;
                this.checkCalendar();
            }

            localStorage.setItem("tourId", this.user.user_uuid);
            if (this.$store.state.rolaPublic == "") {
                //   console.log('1',this.$store.state.rolaPublic)
                if (this.user.rola.indexOf("PLAYER") != -1) {
                    this.rolecolor1 = true;
                    this.activePlayer = true;
                } else if (this.user.rola.indexOf("CLUBADMIN") !== -1) {
                    this.rolecolor2 = true;
                    this.activeClub = true;
                } else if (this.user.rola.indexOf("ORGANIZER") !== -1) {
                    this.rolecolor3 = true;
                    this.activeOrg = true;
                } else if (this.user.rola.indexOf("ARBITER") !== -1) {
                    this.rolecolor4 = true;
                    this.activeArb = true;
                } else if (this.user.rola.indexOf("TRAINER") !== -1) {
                    this.rolecolor5 = true;
                    this.activeTre = true;
                } else if (this.user.rola.indexOf("OTHER") !== -1) {
                    this.rolecolor6 = true;
                    this.activeOth = true;
                } else if (this.user.rola.indexOf("STREAMER") !== -1) {
                    this.rolecolor7 = true;
                    this.activeStr = true;
                } else if (this.user.rola.indexOf("CHESSBOX") !== -1) {
                    this.rolecolor8 = true;
                    this.activeBox = true;
                }
            } else {
                // console.log('2',this.$store.state.rolaPublic)
                switch (this.$store.state.rolaPublic) {
                    case 1:
                        this.activePlayer = true;
                        this.rolecolor1 = true;
                        break;
                    case 2:
                        this.activeClub = true;
                        this.rolecolor2 = true;
                        break;
                    case 3:
                        this.rolecolor3 = true;
                        this.activeOrg = true;

                        break;
                    case 4:
                        this.activeTre = true;
                        this.rolecolor5 = true;
                        break;
                    case 5:
                        this.activeArb = true;
                        this.rolecolor4 = true;
                        break;
                    case 6:
                        this.activeOth = true;
                        this.rolecolor6 = true;
                        break;
                    case 7:
                        this.activeStr = true;
                        this.rolecolor7 = true;
                        break;
                    case 8:
                        this.activeBox = true;
                        this.rolecolor8 = true;
                        break;
                }
            }
        },
        scroll() {
            // console.log('ideeee')
            document.getElementById("calendar").scrollIntoView({ behavior: "smooth" });
        },
        openLinkupPicker() {
            //  console.log('intercommm')
            // this.clickActive3
            if (window.innerWidth < 500) {
                this.clickActive3 = false;
                this.calendarUser = false;
            } else {
                this.clickActive3 = true;
            }
            this.clickActive1 = false;
            this.clickActive2 = false;
            let linkupClick = true;
            let email = this.$store.state.current_user.email;
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "qfb2wowv",
                email: email, // Email address,
                user_hash: localStorage.getItem("H"),
                LinkupClick: linkupClick,
            });

            document.getElementById("calendar").scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                //  this.autoAnswer=false;
                this.test();
            }, 400);
        },
        test() {
            this.calendarUser = true;
            // console.log('this.calendarUser',this.calendarUser)
        },
        checkCalendar() {
            if (this.user.time_zone !== null && this.user.time_zone !== null && this.user.time_zone !== null) {
                if (this.logedIn) {
                    fetch(process.env.VUE_APP_URL + `/user_work_days/${this.idt}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    })
                        .then(response => response.json())
                        .then(data => (this.trainerData = data))
                        // .then(data => console.log("trainerData", data))
                        .then(this.checkCalendarView);
                } else {
                    fetch(process.env.VUE_APP_URL + `/user_work_days/${this.idt}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                        .then(response => response.json())
                        .then(data => (this.trainerData = data))
                        .then(this.checkCalendarView);
                }
            }
        },

        receiveNotif(payload) {
            //console.log('received a notif', payload)
            //this.notif_arr=[payload,...this.notif_arr]
            //console.log(this.$store.state.counter)
            this.$store.commit("receiveNotif", payload);
        },

        cvdairycal(e) {
            this.clickActive1 = false;
            this.clickActive2 = false;
            this.clickActive3 = false;
            this[e] = true;
        },

        role_indicator: function (rola) {
            this.activePlayer = false;
            this.activeClub = false;
            this.activeOrg = false;
            this.activeTre = false;
            this.activeArb = false;
            this.activeOth = false;
            this.activeBox = false;
            this.rolecolor1 = false;
            this.rolecolor2 = false;
            this.rolecolor3 = false;
            this.rolecolor4 = false;
            this.rolecolor5 = false;
            this.rolecolor6 = false;
            this.rolecolor7 = false;
            this.rolecolor8 = false;
            switch (rola) {
                case 1:
                    this.activePlayer = true;
                    this.rolecolor1 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 2:
                    this.activeClub = true;
                    this.rolecolor2 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 3:
                    this.activeOrg = true;
                    this.rolecolor3 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 4:
                    this.activeTre = true;
                    this.rolecolor5 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 5:
                    this.activeArb = true;
                    this.rolecolor4 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 6:
                    this.activeOth = true;
                    this.rolecolor6 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 7:
                    this.activeStr = true;
                    this.rolecolor7 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
                case 8:
                    this.activeBox = true;
                    this.rolecolor8 = true;
                    this.$store.commit("SET_ROLE_SCREEN_PUBLIC", rola);
                    break;
            }
        },

        connection_initiate() {
            this.unfollowed = false;
            // console.log('unfolled',this.unfollowed)
            //  console.log('unfollowButton',this.unfollowButton)
            //  console.log('connect',this.connecting_initiation)
            //  console.log('deleteConnectionButton',this.deleteConnectionButton)
            fetch(process.env.VUE_APP_URL + `/connection_initiate/${this.idt} `, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: null,
            })
                .then(response => response.json())
                .then(data => (this.newConnection = data))
                // .then(data => console.log("konekcijalizacija", data))
                .catch(error => {
                    console.error(error);
                });

            this.$store.commit("ADD_FOLLOWING", this.idt);
            this.unfollowed = false;
            // setTimeout(() => this.opacityAnimation(), 300);
        },
        opacityAnimation() {
            this.connecting_initiation = true;
            fetch(process.env.VUE_APP_URL + "/connection_list", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())
                .then(data => (this.my_connection = data))
                // .then(data => console.log("connection list", data))
                .then(this.connectionStore);
        },
        connectionStore() {
            this.$store.commit("MY_CONNECTION_LIST", this.my_connection);
        },
        disconnection_people: function () {
            fetch(process.env.VUE_APP_URL + `/connection_initiator_delete/${this.idt} `, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: null,
            }).catch(error => {
                console.error(error);
            });
        },
        toggleSidebarParent() {
            this.isSidebarOpen = !this.isSidebarOpen;
        },
        toggleSidebarParentClose() {
            this.isSidebarOpen = false;
        },
    },
}; /*  // "lightvue": "^0.5.1",   */
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.opacity0 {
    opacity: 0 !important;
    transition: 0.5s;
}
.opacity1 {
    opacity: 1 !important;
    transition: 0.5s;
}
.shadow {
    opacity: 0.5;
}
.federation2 >>> .v-btn {
    width: 18px !important;
    height: 18px;
}
.federation2 >>> .v-application .ma-4 {
    display: flex;
    margin: 0 !important;
}
.federation2 >>> .v-btn:not(.v-btn--round).v-size--default {
    min-width: 32px !important;
    padding: 0 3px;
}
.correct-height {
    max-height: 100vh;
    overflow: hidden;
}

.federation2 >>> .v-btn--is-elevated {
    box-shadow: none !important;
}
.federation2 >>> .theme--light.v-application {
    background: #202122;
}
.federation2 >>> .v-application .primary {
    background-color: #202122 !important;
}
.federation2 >>> .theme--dark.v-btn:hover::before {
    opacity: 0;
}
</style>
<style scoped lang="scss">
html {
    scroll-behavior: smooth;
}
a {
    text-decoration: none;
    font-size: 14px;
}
a:hover {
    color: #c8a07d;
    opacity: 0.7;
}
.wrapper {
    width: 90%;
    margin-inline: auto;
}
.federation2 {
    display: flex;
    img {
        width: 28px;
    }
}
// .pay-desktop {
//     border: 0.5px solid #5c5e64;
//     border-radius: 100px;
//     width: 140px;
//     height: 34px;
//     &:hover {
//         opacity: 1 !important;
//         cursor: pointer;
//         border: 0.5px solid #c8a07d;
//     }
// }
.arrow-active {
    //transition: 0.5s linear;
    transform: rotate(90deg) !important;
    transition: 0.3s ease-in-out;
}
.blog {
    position: absolute;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    z-index: 5;
    background-color: #1b1c1f;
    overflow-y: scroll;
}
.unfollow-button {
    transition: 0s !important;
    border: 0.5px solid #f2358d;
    border-radius: 100px;
    width: 140px !important;
    height: 34px;
    color: #f2358d !important;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        opacity: 0.7;
        cursor: pointer;
        border: 0.5px solid #f2358d !important;
    }
}
.role-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    img {
        margin-left: 10px;
        height: 22px;
    }
    @media only screen and (max-width: 640px) {
        margin-top: 8px;
        margin-bottom: 0px;
    }
}

.public-follow {
    justify-content: flex-end;
    align-items: flex-end;
    display: flex;
    //  margin-right: 30px;
    //margin-top: 12px;
    @media only screen and (max-width: 640px) {
        justify-content: center;
        align-items: center;
        margin-right: 0px;
        // margin-top: 3px;

        // div {
        //     top: 52px;
        //     width: 100%;
        // }
    }
}

// .pay-desktop p {
//     margin-left: 10px;
//     font-size: 14px;
// }
.message-desktop:hover {
    border: 1px solid #c8a07d;
    opacity: 1 !important;
    cursor: pointer;
    position: relative;
}
.hover-text {
    position: absolute;
    right: 40px;
    opacity: 0;
    word-break: keep-all;
    width: max-content;
    color: #6f7381 !important;
}
* {
    letter-spacing: 0.85px;
}
.no-margin {
    margin: 0 !important;
}
.hover-text-icons {
    position: absolute;
    left: -4pxpx;
    top: -22px;
    opacity: 0;
    word-break: keep-all;
    width: max-content;
    color: #6f7381 !important;
}
.hover-text-icons-mobile {
    position: absolute;
    left: -4pxpx;
    top: 35px;
    z-index: 10;
    opacity: 0;
    word-break: keep-all;
    width: max-content;
    background-color: #202122;
    border: 1px solid #6f7381;
    color: #6f7381 !important;
    padding: 3px 5px;
    border-radius: 6px;
}
.hover-text2 {
    position: absolute;
    left: 40px;
    opacity: 0;
    word-break: keep-all;
    width: max-content;
    color: #6f7381 !important;
}
.hover-text-active {
    opacity: 1;
    //right:100px;
}
.hover-text-active2 {
    opacity: 1;
    left: 40px;
}
.message-div {
    margin-top: 5px;
    margin-bottom: 5px;
}

.message-desktop,
.pay-desktop {
    border: 0.5px solid #6f7381;
    border-radius: 100px;
    height: 32px;
    width: 32px;
    margin-left: 0px;
    margin-right: 0px;
    position: relative;
    &:hover {
        cursor: pointer;
        border: 0.5px solid #c8a07d;
    }
}
.biography {
    display: none;
    word-wrap: break-word;
}

.fide-id {
    color: #c8a07d;
    padding-left: 0.5rem;
    &:hover {
        cursor: pointer !important;
    }
}

.middle2-button-container {
    display: none;
}

a:hover {
    text-decoration: none;
}

hr {
    border: 0.5px solid rgba(199, 201, 208, 0.2);
    width: 80%;
}

.profile {
    display: grid;
    position: relative;
    grid-template-columns: 16.25rem auto;
}
.biography img {
    //padding-top: 6px;
}

.right-profile {
    background-color: #1b1c1d;
}

#side-bar {
    height: 100%;
    width: 100%;
    background-color: #202122;
    color: #ffffff;
    padding: 4.375rem 0.625rem 3.125rem 0.625rem;
    font-size: 0.875rem;
}
.color-button {
    width: auto;
    height: 30px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 0px 10px;
    margin-right: 18px;

    p {
        color: #ffffff;
        margin-left: 8px;
        font-weight: 600;
        font-size: 13px;
    }
    &:hover {
        cursor: pointer;
        opacity: 0.7;
    }
    @media only screen and (max-width: 640px) {
        border-radius: 8px;
        margin-right: 5px;
        margin-left: 5px;
        p {
            margin-left: 3px;
            font-weight: 600;
            font-size: 14px;
        }
    }
}
.no-desktop {
    display: none !important;
    @media only screen and (max-width: 640px) {
        display: block !important;
    }
}
.color-button-learn {
    background-color: #11c6d1;
}
.color-button-link {
    background-color: #f2358d;
}
.color-button-match {
    background-color: #07da63;
    @media only screen and (max-width: 640px) {
    }
}

.left-sidetext {
    padding-left: 0.9375rem;
    cursor: pointer;
}

.diffcol {
    color: rgba(199, 201, 208, 0.2);
}
.svg_verified {
    margin-left: 10px;
    //  margin-top: 2px;
}
/*--------------------------Check-------------------------------------- */

.pay-message {
    color: rgba(255, 255, 255, 1);
    border: 1px solid #5c5e64;
    border-radius: 8px;
    width: 138px;
    height: 35.7px;
    font-size: 16px;
    font-weight: 700;
    margin: 0 5px;
}
.federation {
    display: flex;
    margin-right: 8px;
    img {
        width: 1.35rem;
    }
}
.sm-hide {
    justify-content: flex-start !important;
}
.inactive {
    opacity: 0.3 !important;
}
.pay-message:hover {
    opacity: 0.7;
    cursor: pointer;
}
.pay-message p {
    padding-left: 5px;
}
.pay-message svg {
    margin-right: 5px;
}

/*--------------------------MIDLE1-------------------------------------- */

/*--------------------------MIDLE2-------------------------------------- */
#middle2 {
    height: 8.75rem;
    background-color: #202122;
    display: grid;
    padding: 0px 0.9375rem 0px 3.0625rem;
    grid-template-columns: 8.285rem 47% auto;
    color: #6f7381;
    margin-top: 1.7625rem;
    border: 1px solid rgba(84, 84, 84, 0.2);
    @media only screen and (max-width: 640px) {
        border: none;
    }
    @media only screen and (max-width: 1440px) {
        grid-template-columns: 8.285rem 45% auto;
    }
    @media only screen and (max-width: 1360px) {
        grid-template-columns: 8.285rem 40% auto;
    }
}

.profile-info1 {
    display: flex;
    align-items: center;
    height: 32px;
}

.profile-info1-1 {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    height: 32px;
}

.profile-info1-1 > img {
    padding-right: 7px;
}

.upload-pic {
    //padding-right: 1.875rem;
    width: 6.785rem;
}

.profile-pic {
    border-radius: 50%;
    height: 6.785rem;
    width: 6.785rem;
    object-fit: cover;
    border: 1px solid #11c6d1;
}
.inicials {
    border-radius: 50%;
    // background-color: rgba(111, 115, 129, 1);
    background-color: rgba(81, 60, 42, 1);
    height: 108px;
    width: 108px;
    //color: rgba(255, 255, 255, 0.7);
    font-weight: 600;
    color: #c8a07d;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
}

.personal-first-line {
    display: flex;
    align-items: center;

    svg {
        width: 19px;
    }
}
#profile-name {
    text-wrap: nowrap;
    font-weight: 700;
    font-style: normal;
    font-weight: bold;
    color: #c8a07d;
    display: flex;
    height: 1.25rem;
    font-size: 20px;
    letter-spacing: 0.3px;
    height: 32px;
}

#middle2-1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.padd-text {
    padding-left: 1.625em;
}
.titles,
.info-par {
    transition: 0s !important;
    font-size: 16px !important;
}
#middle2-flag {
    height: 1.875rem;
    padding: 0 1.875rem 0 0.625rem;
}

#middle2-flag:hover {
    cursor: pointer;
}

.svg-pancil:hover {
    opacity: 0.7;
}

/*--------------------------MIDDLE3-------------------------------------- */
.menu-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 75px;
    border-top: 1px solid #2a2c30 !important;
    border-bottom: 1px solid #2a2c30 !important;
    display: none;
    // padding-inline: 1rem;
    @media only screen and (max-width: 640px) {
        display: flex;
    }
}
.menu {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25%;
    color: #ceceda;
    height: 100%;
    font-size: 14px;
    font-weight: 600;
}
.menu-active {
    color: #11c6d1;
    border-bottom: 1px solid #11c6d1;
}
#middle3 {
    display: grid;
    grid-template-columns: 56% 44%;
    height: 5rem;
}

::placeholder {
    color: #ffffff;
    font-weight: 300;
    font-size: 0.875rem;
}
::-webkit-scrollbar {
    display: none;
}

.titles {
    cursor: pointer;
    border: #c8a07d solid 1px;
    border-radius: 1.25rem;
    -webkit-border-radius: 1.25rem;
    -moz-border-radius: 1.25rem;
    width: 5.125rem;
    height: 2rem;
    margin-left: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 0.875rem;
}

.remove_click {
    color: #ffffff;
    cursor: pointer;
}
.online-lamp {
    width: 1.1rem;
    height: 1.1rem;
    background-color: #07da63;
    position: absolute;
    border-radius: 50%;
    right: 9px;
    bottom: 9px;
    outline: 4px solid #202122;
    @media only screen and (max-width: 640px) {
        right: 3px;
        bottom: 3px;
        outline: 3px solid #202122;
        width: 1.06rem;
        height: 1.06rem;
    }
}
.online-lamp-container {
    position: relative;
}
.middle3-1 {
    display: flex;
    align-items: center;
}
.middle3-1a {
    justify-content: space-around !important;
    margin-right: 40px;
}
.follow-desktop {
    //  margin-right: 16px;

    &:hover {
        cursor: pointer;
        border: 0.5px solid #c8a07d;
    }
}
.follow-desktop-active {
    opacity: 1;
    border: none !important;
    &:hover {
        opacity: 1 !important;
        cursor: default;
    }
}
.middle3-1-1 {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    transition: 0s;
}
.id-number {
    margin-bottom: 4px;
    margin-left: 10px;
}
.ratings {
    width: 7.5rem;
    height: 2rem;
    margin-left: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 0.875rem;
    border: #c8a07d solid 1px;
    border-radius: 1.25rem;
    -webkit-border-radius: 1.25rem;
    -moz-border-radius: 1.25rem;
}

.ratingsi {
    background-color: #202122;
    border: #c8a07d solid 1px;
    border-radius: 1.25rem;
    -webkit-border-radius: 1.25rem;
    -moz-border-radius: 1.25rem;
    width: 7.5rem;
    height: 2rem;
    margin-left: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff !important;
    font-size: 0.875rem;
}
.sm-show {
    display: none;
    @media only screen and (max-width: 640px) {
        display: flex;
    }
}

.rola-text {
    background: #c8a07d;
    border-radius: 20px;
    width: 5rem;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    color: #3a332d !important;
    font-size: 0.875rem;
    font-weight: 600 !important;
}

.text-ratings {
    color: #c8a07d;
    padding-right: 0.625rem;
}

/*--------------------------MIDDLE4-------------------------------------- */
#middle4 {
    height: 3.875rem;
    background-color: #202122;
    display: grid;
    grid-template-columns: 55% 45%;
    border: 1px solid rgba(84, 84, 84, 0.2);
}

.middle4-1 {
    color: #6f7381;
    font-size: 0.875rem;
    margin: auto;
    width: 8rem;
    border-radius: 1.25rem;
}

.middle4-1:hover {
    cursor: pointer;
    text-decoration: none;
}

.add-remove {
    color: #ffffff;
    padding-left: 5px;
    font-size: 1.25rem;
    cursor: pointer;
}

/*--------------------------MIDDLE5-------------------------------------- */
.no-wrap {
    text-wrap: nowrap;
}
#middle5 {
    display: grid;
    grid-template-columns: 54.5% 44.5%;
    gap: 1%;
    height: auto;
    margin: 1% 0 1.875rem 0;
    color: #ffffff;
}
.middle5-left {
    border: 1px solid rgba(84, 84, 84, 0.2);
}
.middle5-right-grid {
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 2%;
    height: 10rem;
    margin-bottom: 2%;
    text-align: left;
}

.middle5-right-grid2 {
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 2%;
    min-height: 10rem;
    margin-bottom: 2%;
    text-align: left;
}

#list-event {
    padding-left: 5%;
    padding-top: 0.9375rem;
}

.title-arrow {
    padding-left: 0.5rem;
}

p {
    margin-bottom: 0;
}

.middle5-right-grid > div {
    background-color: #202122;
}

.middle5-right-grid2 > div {
    background-color: #202122;
}

.middle5-left {
    background-color: #202122;
}

.gold {
    color: #c8a07d;
    font-size: 0.875rem;
    margin-top: 10%;
    padding-left: 1.25rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.grid-check {
    padding-bottom: 0.9375rem;
    font-size: 1.125rem;
    transform: scale(0.7);
    transform-origin: left;
}

#check-engagements {
    width: 100%;
    margin-right: auto;
    padding: 0 0 0 0;
}

#pre-select {
    display: flex;
}

#select-css {
    color: #ffffff;
    background-color: #202122;
    width: 4.75rem;
    border-radius: 3px;
    margin-left: 1.5625rem;
    outline: 0px;
    border: none;
    cursor: pointer;
    font-size: 0.75rem;
}

#select-css2 {
    color: #ffffff !important;
    width: 8.75rem;
    border-radius: 3px;
    margin-left: 1.5625rem;
    outline: 0px;
    border: none;
    cursor: pointer;
    font-size: 0.875rem;
    background-color: #202122;
}
.middle2-1-button-container {
    display: flex;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 0;
    max-height: 100%;
    a {
        margin: 0px;
    }

    //  padding-top: 1rem;
}
.public-profile-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    @media only screen and (max-width: 640px) {
        align-items: center;
    }
}
.public-center-right {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    @media only screen and (max-width: 640px) {
        margin-top: 20px;
    }
}
.public-center-right-div {
    display: flex;
    width: 100%;
    //justify-content: center;
    justify-content: flex-end;
    align-items: center;

    @media only screen and (max-width: 640px) {
        justify-content: center;
    }
}

.middle2-1-button-container p {
    color: rgba(233, 233, 233, 1);
}

/* CLUB */

/* Hide default HTML checkbox */

@media only screen and (max-width: 1440px) {
    .ratings {
        margin-left: 14px;
    }
}
@media only screen and (max-width: 1280px) {
    .ratings {
        margin-left: 10px;
    }
}

@media only screen and (max-width: 1500px) and (min-width: 1025px) {
    .profile {
        grid-template-columns: 16.25rem auto;
    }
}

@media only screen and (max-width: 1024px) {
    .profile {
        grid-template-columns: auto;
        font-size: 0.875rem;
    }
    .roles {
        overflow-x: scroll;
    }
}

@media only screen and (max-width: 640px) {
    .bottom-calendar {
        min-height: 680px;
    }
    .id-number {
        p {
            top: -2px;
        }
    }
    .flex-center-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 4px;
        }
    }
    .desktop {
        display: none;
    }
    .profile-info1 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        margin-bottom: 6px;
    }
    .profile-info1-1 > img {
        padding-right: 0px;
        padding-bottom: 0rem;
    }
    .profile-info1-1 {
        width: auto;
        div {
            justify-content: center;
            align-items: center;
        }
    }

    .personal-first-line {
        justify-content: center;
        svg {
            margin-top: 4px;
        }
    }
    .wrapper {
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }

    .sm-hide {
        display: none;
    }
    .bold {
        font-weight: bold;
    }
    body {
        background-color: #1b1c1f;
    }
    .right-profile {
        grid-template-columns: 1fr;
        height: 100vh;
        overflow-y: scroll;
    }
    #middle5 {
        display: grid;
        grid-template-columns: 54.5% 44.5%;
        gap: 0%;
        height: auto;
        margin: 1% 0 1.875rem 0;
        color: #ffffff;
        gap: 0%;
    }

    .titles,
    .ratings,
    .info-par,
    .rola-text,
    .middle4-1 {
        font-size: 14px !important;
    }
    .ratings,
    .titles {
        width: auto;
        height: auto;
        padding-block: 0.4rem;
        padding-inline: 2.5rem;
        margin-left: 2.5rem;
    }

    .middle2-button-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 0;
        position: relative;
        bottom: 0px;
        a {
            margin-left: 0px;
        }
    }
    .middle2-1-button-container {
        display: none;
    }

    #middle2 {
        display: flex;
        flex-direction: column;
        height: auto;
        text-align: start;
        justify-content: space-between;
        align-items: center;
        padding-top: 2rem;
        padding-bottom: 29px;
        padding-left: 0;
        padding-right: 0;
    }
    .message-mobile {
        position: absolute;
        z-index: 50;
        display: flex;
        flex-direction: column;
        width: 40px;
        height: 40px;
        img {
            width: 40px;
            height: 40px;
        }
        right: 20px;
        top: 110px;
    }

    .upload-pic {
        padding-right: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 10px;
    }
    .profile-pic {
        border: 1px solid #11c6d1;
        width: 106px;
        height: 106px;
    }
    #middle2 {
        background-color: #1b1c1f;
        padding-top: 0;
    }
    #middle2-1 {
        padding-left: 0;
        margin-bottom: 10px;

        flex-direction: column;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    #profile-name {
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        color: white;
        // padding-bottom: 1.25rem;
        height: 50px;
        text-wrap: wrap;
        text-align: center;
    }

    #middle3 {
        display: flex;
        flex-direction: column;
        //padding-left: 2.917rem;
        height: 73px;
    }
    #middle4 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow-x: scroll;
    }
    .middle3-1-title {
        border-bottom: 1px solid #2a2c30;
    }
    .middle3-1 {
        height: 88px;
        border-bottom: 1px solid #2a2c30;
        overflow-x: scroll;

        &-1 {
            padding-left: 2.917rem;
        }

        &:first-of-type {
            //  border-top: 1px solid #2a2c30;
        }
    }
    .middle3-1-blog {
        height: 440px;
        border-bottom: 1px solid #2a2c30;
        overflow-x: scroll;

        position: relative;
        margin-top: -80px;
        &-1 {
            padding-left: 2.917rem;
        }
    }

    .no-title-mobile {
        display: none;
    }
    .rating {
        padding-left: 2.917rem;
    }
    .svg-follow {
        margin-top: 0.5rem;
    }
    .bottom {
        margin-top: 10px;
    }
    .bio-calendar {
        padding-top: 2rem !important;
    }
    .biography {
        display: block;
        text-align: start;
        padding: 0rem 2.5rem 2rem 0;
        border-bottom: 1px solid #2a2c30;

        .top {
            padding-left: 2.917rem;
            display: flex;
            justify-content: space-between;
            // margin-bottom: 0.542rem;

            p {
                color: #c8a07d;
                font-size: 1.333rem;
            }
        }

        .bottom p {
            padding-left: 2.917rem;
            width: 90%;
            color: #6f7381;
            font-size: 1.167rem;
        }
    }
    #middle4 {
        background-color: unset;
        padding-left: 3rem;
        justify-content: center;
        height: auto;
        border: none;
        .middle3-1 {
            border-bottom: none;
        }
    }
    .middle4-1 {
        font-weight: 500;
    }
    .rola-text {
        margin-block: 0;
    }
    .roles {
        height: auto;
        margin-top: 2.4rem;
        margin-bottom: 2.4rem;
    }
    #middle5 {
        display: flex;
        justify-content: center;
        margin-top: 0;
    }

    .middle5-left {
        display: none;
    }
    .main-right {
        width: 100%;
    }
    .middle3-height {
        height: 88px !important;
        border-top: 1px solid #2a2c30;
    }
    .middle3-height-zero {
        height: 0px !important;
        transition: 0s;
    }
    .biography-height-zero {
        height: 0px !important;
        min-height: 0px;
    }
    .biography-height-final {
        min-height: 100px;
        height: auto;
        max-height: 310px !important;
        position: relative;
        margin-top: -60px;
    }
}

@media screen and (max-width: 320px) {
    .wrapper {
        width: 100%;
    }
    #middle3 {
        overflow-x: scroll;
    }
    .middle3-1 {
        width: fit-content;

        &:first-of-type {
            width: 100%;
        }
    }
    .ratings {
        &:last-child {
            margin-right: 2rem;
        }
    }
}
</style>
